import { Modal, OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import { PencilFill } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { useOrdenation } from '../../../hooks/useOrdenation'
import { formatPrice } from '../../../utils/formatPrice'
import { CustomButton } from '../../CustomButton'

export function ModalConsultarHeranca({ isOpen, onClose, dad, kids }) {
  const { filteredItems, Th, Paginate } = useOrdenation(kids, 'sku')

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header closeButton>
        <Modal.Title>Consultar Herança</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {dad && (
          <Table
            responsive
            hover
            bordered
            striped
          >
            <thead>
              <tr>
                <th colSpan={localStorage.admin === 'SIM' ? 6 : 5}>
                  <p>Produto Pai</p>
                </th>
              </tr>

              <tr>
                <th
                  style={{
                    fontSize: 12,
                  }}
                >
                  SKU
                </th>

                <th
                  style={{
                    fontSize: 12,
                  }}
                >
                  Descrição
                </th>

                <th
                  style={{
                    fontSize: 12,
                  }}
                >
                  Quantidade
                </th>

                {localStorage.admin === 'SIM' && (
                  <th
                    style={{
                      fontSize: 12,
                    }}
                  >
                    Preço Custo
                  </th>
                )}

                <th
                  style={{
                    fontSize: 12,
                  }}
                >
                  Preço Venda
                </th>

                <th
                  style={{
                    fontSize: 12,
                  }}
                >
                  Ações
                </th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td
                  style={{
                    fontSize: 12,
                  }}
                >
                  {dad?.sku}
                </td>

                <td
                  style={{
                    fontSize: 12,
                  }}
                >
                  {dad?.descricao}
                </td>

                <td
                  style={{
                    fontSize: 12,
                  }}
                >
                  {dad?.quantidade}
                </td>

                {localStorage.admin === 'SIM' && (
                  <td style={{ fontSize: 12 }}>
                    <td
                      style={{
                        fontSize: 12,
                      }}
                    >
                      {dad?.precocusto}
                    </td>
                  </td>
                )}

                <td
                  style={{
                    fontSize: 12,
                  }}
                >
                  {dad?.precovenda}
                </td>

                <td
                  style={{
                    fontSize: 12,
                  }}
                >
                  <Link
                    to={`/produtos/${dad?.codproduto}`}
                    target="_blank"
                  >
                    <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                      <CustomButton color="#f54927">
                        <PencilFill fontSize={12} />
                      </CustomButton>
                    </OverlayTrigger>
                  </Link>
                </td>
              </tr>
            </tbody>
          </Table>
        )}

        {filteredItems.length > 0 && (
          <>
            <Table
              responsive
              hover
              bordered
              striped
            >
              <thead>
                <tr>
                  <th colSpan={localStorage.admin === 'SIM' ? 6 : 5}>
                    <p>Produtos Filhos</p>
                  </th>
                </tr>

                <tr>
                  <Th
                    label="SKU"
                    value="sku"
                    style={{ fontSize: 12 }}
                  />

                  <Th
                    label="Descrição"
                    value="descricao"
                    style={{ fontSize: 12 }}
                  />

                  <Th
                    label="Quantidade"
                    value="quantidade"
                    style={{ fontSize: 12 }}
                  />

                  {localStorage.admin === 'SIM' && (
                    <Th
                      label="Preço Custo"
                      value="precocusto"
                      style={{ fontSize: 12 }}
                    />
                  )}

                  <Th
                    label="Preço Venda"
                    value="precovenda"
                    style={{ fontSize: 12 }}
                  />

                  <th style={{ fontSize: 12 }}>Ações</th>
                </tr>
              </thead>

              <tbody>
                {filteredItems.map((kid) => (
                  <tr key={kid.codproduto}>
                    <td style={{ fontSize: 12 }}>{kid.sku}</td>
                    <td style={{ fontSize: 12 }}>{kid.descricao}</td>
                    <td style={{ fontSize: 12 }}>{kid.quantidade}</td>

                    {localStorage.admin === 'SIM' && (
                      <td style={{ fontSize: 12 }}>
                        {formatPrice(kid.precocusto)}
                      </td>
                    )}

                    <td style={{ fontSize: 12 }}>
                      {formatPrice(kid.precovenda)}
                    </td>
                    <td>
                      <Link
                        to={`/produtos/${kid.codproduto}`}
                        target="_blank"
                      >
                        <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                          <CustomButton color="#f54927">
                            <PencilFill fontSize={12} />
                          </CustomButton>
                        </OverlayTrigger>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <Paginate />
          </>
        )}
      </Modal.Body>
    </Modal>
  )
}
